window._mode='front';window._protocol='https://';window._domain='www.votre-etiquette.com';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/ve/';window._api='/api/v2/';
import cwException from 'components/exception.js';

export default function fastSearch()
{

    const field = document.getElementById('search-field');

    if (field)
    {
        // debounce implementation: wait a short time after last keystroke
        let debounceTimer = null;
        let lastController = null;
        const DEBOUNCE_MS = 350; // latency in ms before firing request

        field.addEventListener('keyup', function()
        {
            const value = field.value;

            // clear previous timer
            if (debounceTimer) {
                clearTimeout(debounceTimer);
                debounceTimer = null;
            }

            // if input too short, optionally notify to clear results
            if (!value || value.length < 3) {
                // abort any pending fetch
                if (lastController) {
                    try { lastController.abort(); } catch (e) {}
                    lastController = null;
                }
                // dispatch an empty result so listeners can clear UI
                field.dispatchEvent(new CustomEvent('search', {detail: {results: []}}));
                return;
            }

            // schedule the search after debounce delay
            debounceTimer = setTimeout(async () => {
                // abort previous fetch if still pending
                if (lastController) {
                    try { lastController.abort(); } catch (e) {}
                    lastController = null;
                }

                const controller = new AbortController();
                lastController = controller;

                try {
                    const res = await fetch(`${_api}search/query/?q=${encodeURIComponent(value)}&limit=6`, {
                        method: 'GET',
                        signal: controller.signal
                    });

                    // clear controller reference on success
                    lastController = null;

                    const msg = await res.json();

                    if (res.status != 200) {
                        throw new cwException(msg);
                    }

                    field.dispatchEvent(new CustomEvent('search', {detail: msg}));
                    return msg;
                } catch (err) {
                    // ignore abort errors, rethrow others
                    if (err.name === 'AbortError') {
                        // aborted due to new request; do nothing
                        return;
                    }
                    throw err;
                }
            }, DEBOUNCE_MS);
        });
    }
}